import { Group, Switch, Text, Tooltip } from '@mantine/core';
import { isDayClosed } from 'components/MenuManagement/MenuEdit/Hours/ScheduleSelect/helpers';

type DayOption = {
  value: string | number;
  displayValue: string;
};

type Schedule = {
  uuid?: string;
  tempId?: string;
  startTime: string;
  endTime: string;
  dayIndex: string | number;
  isPeriod?: boolean;
  appliedDate?: string;
};

type DaySwitchProps = {
  primarySchedule: Schedule;
  primaryId: string;
  dayOption?: DayOption;
  hasSecondarySchedules: boolean;
  handleToggle: (id: string) => void;
  minHeight?: number;
};

export default function DaySwitch({
  primarySchedule,
  primaryId,
  dayOption,
  hasSecondarySchedules,
  handleToggle,
  minHeight,
}: DaySwitchProps) {
  const switchId = `day-switch-${primaryId}`;
  const switchComponent = (
    <Group
      data-testid="day-switch-toggle-row"
      gap="xs"
      mih={minHeight}
      wrap="nowrap"
      style={{ display: 'inline-flex' }}
    >
      <Switch
        id={switchId}
        checked={!isDayClosed({ ...primarySchedule, dayIndex: String(primarySchedule.dayIndex) })}
        onChange={() => handleToggle(primaryId)}
        size="xs"
      />
      <Text
        component="label"
        htmlFor={switchId}
        variant="caption-md"
        mr="xs2"
        w="lg"
        style={{ cursor: 'pointer' }}
      >
        {dayOption?.displayValue}
      </Text>
    </Group>
  );

  if (!hasSecondarySchedules) {
    return switchComponent;
  }

  return (
    <Tooltip
      label="Closing this day will also remove the extra periods."
      position="top"
      withArrow
      ml="-xl"
    >
      {switchComponent}
    </Tooltip>
  );
}
